import { createClient, type SupabaseClient } from "@supabase/supabase-js";

/**
 * Supabase-klienten, eller ingen.
 *
 * ER IKKE MILJOEVARIABLENE SATT, FINNES DET INGEN KLIENT — og da finnes det
 * heller ingen innlogging. Appen kjoerer paa froeet i `session.ts`. Det er med
 * vilje: vi skal kunne proeve flatene uten aa logge inn for hver endring, og
 * innloggingen skal bli ekte av seg selv naar prosjektet er satt opp.
 *
 * Verdiene settes i `.env.local` lokalt og som miljoevariabler i Cloudflare
 * Pages. Se `.env.example`.
 */

const url = import.meta.env["VITE_SUPABASE_URL"];
const anon = import.meta.env["VITE_SUPABASE_ANON_KEY"];

export const harSupabase =
  typeof url === "string" && url.length > 0
  && typeof anon === "string" && anon.length > 0;

/**
 * Om innlogging KREVES, uavhengig av om Supabase finnes.
 *
 * `VITE_INFOFLYT_AUTH=av` lar klienten vaere der — saa data kan hentes og
 * lagres mens vi bygger — uten at noen maa logge inn for aa se en endring.
 * Det er standarden mens flatene bygges, og den er skrudd paa i `.env.local`.
 *
 * Grunnen er ikke bekvemmelighet alene: appen skal kunne BRUKES uten
 * innlogging. En VJ eller en liten produksjon som bare logger, trenger ingen
 * konto. Innlogging hoerer til nettflata og de stoerre produksjonene. Se
 * docs/02-arkitektur.md § «Tilgang uten konto».
 */
export const krevInnlogging =
  harSupabase && import.meta.env["VITE_INFOFLYT_AUTH"] !== "av";

export const supabase: SupabaseClient | null = harSupabase
  ? createClient(url as string, anon as string, {
      auth: {
        /*
         * Oekten ligger i localStorage og overlever at appen lukkes. Det er
         * forutsetningen for offline: en som alt har logget inn skal kunne
         * jobbe i kjeller og skog uten aa bli kastet ut. Bare den aller
         * foerste innloggingen trenger nett.
         */
        persistSession: true,
        autoRefreshToken: true,
        // Den magiske lenka kommer tilbake med token i adressen.
        detectSessionInUrl: true,
      },
    })
  : null;
